import { render, staticRenderFns } from "./CaseFluidList.vue?vue&type=template&id=08d38acb&scoped=true&"
import script from "./CaseFluidList.vue?vue&type=script&lang=js&"
export * from "./CaseFluidList.vue?vue&type=script&lang=js&"
import style0 from "./CaseFluidList.vue?vue&type=style&index=0&id=08d38acb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d38acb",
  null
  
)

export default component.exports